"use client";

import Image from "@/components/Image";
import { useState, useEffect, useRef } from "react";
// import { DeviceType, getDeviceTypeByUA } from "@/app/utils";
const Teacher = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [, setFade] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);
  const interval = 2000;
  const [deviceType, setDeviceType] = useState<string>("other");

  // 轮播信息
  const items = [
    {
      id: 1,
      title: "“国培计划”信息化培训专家",
      content:
        "善用信息技术减负的方法，并围绕“作业、测评”，深入分析教师信息化教学能力对提升教学效率、质量的重要性，发现作业、测验结果数据对教学诊断分析的重要意义。近年来携手蜜蜂家校共同推进信息技术与教学的融合，聚焦作业管理智能化，帮助教师运用人工智能技术，实现减负增效。",
      author: "-- 陈教授",
    },
    {
      id: 2,
      title: "丰都滨江中学",
      content:
        "有了这套系统，老师也能更专心帮孩子提分！AI智能批改省下了大量批改时间，老师就能用系统分析出的学情报告，精准找到每个孩子的薄弱点，提前备好课。课堂上，老师还能用作业数据和错题，带着孩子一起分析易错点，把知识点讲的明明白白，真正做到“哪里不会学哪里”、“哪里不会教哪里”！",
      author: "-- 舒老师",
    },
    {
      id: 3,
      title: "三元区某小学",
      content:
        "课堂模式，上课讲题的那个还挺好的。 在白板上讲，我可以让孩子知道题目错在哪里。这也是我跟家长讲我为什么要用这个。因为上课的时候我可以讲这个屏幕，看到错题分布情况。比如我想抓一些同学，这么简单的题目还在做错，点开一看到底是谁，甚至原卷截图都有。很多孩子学习不理想，其实就在于那种很简单的题目一直在错。通过这个功能他们就能知道这种题目不能错。难的题目我也可以看。比如一张卷子，第一年的时候，一张卷子这么多题目，我每题都要讲过去，我也不知道他们错哪里。但是我看到这个，我说这一题有十几个人做错。我问他们这题会不会，没有人说话。会的都是会的。如果没有这功能，我不知道他们到底会不会，我还以为他们真的会。结果一看还有十几个人错，那肯定要讲。通过这个功能我就可以精准讲评。",
      author: "-- 赵老师",
    },
    {
      id: 4,
      title: "四会市某镇中心小学",
      content:
        "任教于一所乡镇小学，教五年级两个班的英语，每个班大约30到35人。我最初是通过小某书了解到并开始使用咱们这款小程序的。吸引我的首先是它免费；其次，考虑到乡镇学生在英语朗读方面练习较少，并且有时家长可能不太清楚作业情况，例如我布置了作业，家长不清楚情况，有时还会反过来问老师是否布置了作业。这款小程序能帮助家长了解孩子当天的学习任务，从而引起他们对孩子学习的重视，确保家长知道当天的作业是什么。",
      author: "-- 黄老师",
    },
    {
      id: 5,
      title: "某小学数学老师",
      content:
        "我基本上现在所有作业都依靠蜜蜂家校，天天都用，一天用好几次。比如周一要上课的班级，周一当天发作业，上课前发布预习作业，上课结束发布当天需提交的作业。课后，我还会用蜜蜂家校跟家长反馈谁完成了、完成得怎么样。每周课前给家长反馈上一周完成情况，错误率高的题型等。有的孩子以前作业拖拉，为了多得红花，会为了红花当天晚上认真写作业。高年级孩子更明显，这个年级孩子会突然发奋，家长也开心，能看到反馈结果，家长比较满意。",
      author: "-- 李老师",
    },
  ];

  // 在组件挂载时获取设备类型
  useEffect(() => {
    import("current-device").then((module) => {
      const deviceType = module.default.type;
      setDeviceType(deviceType);
      if (deviceType === "desktop") {
        setDeviceType("pc");
      }
      if (deviceType === "unknown") {
        setDeviceType("other");
      }
    });
  }, []);

  useEffect(() => {
    // 切换到下一个项目
    const goToNext = () => {
      setFade(false);
      setTimeout(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % items.length);
        setFade(true);
      }, 300); // 与CSS过渡时间匹配
    };

    // 设置定时器
    const setupTimer = () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (!isHovered) {
        timerRef.current = setInterval(goToNext, interval);
      }
    };
    setupTimer();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [isHovered, items.length]);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <section className="w-full px-[80px] [@media(min-width:769px)_and_(max-width:1080px)]:px-[40px] [@media(max-width:768px)]:px-[20px] flex flex-col items-center bg-white">
      <div className="w-full max-w-[1360px] flex flex-col gap-[66px] pt-[90px] pb-[140px] [@media(max-width:768px)]:pb-[90px]">
        <div className="w-full flex flex-col gap-[20px]">
          <div className="font-[PingFang-SC] font-semibold text-[46px] [@media(min-width:415px)_and_(max-width:660px)]:text-[40px] [@media(max-width:414px)]:text-[clamp(2rem,9vw,2.5rem)] leading-[52px] tracking-[0px] text-center text-[#333333]">
            老师们这么说
          </div>
          <div className="font-[PingFang-SC] font-normal text-[18px] [@media(max-width:660px)]:text-[14px] leading-[28px] tracking-[2px] text-center text-[#666666]">
            来自老师的真实体验感受
          </div>
        </div>
        {/*轮播图模块*/}
        <div
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          className="bg-[#F6F8FB] w-full min-h-[380px] rounded-[20px] pt-[50px] px-[60px] [@media(min-width:415px)_and_(max-width:768px)]:px-[40px] [@media(max-width:414px)]:px-[20px] pb-[60px] [@media(max-width:414px)]:py-[20px] gap-[20px] cursor-pointer"
        >
          <div className="h-full w-full flex flex-col gap-[20px]">
            <div className="h-[24px] w-[26px]">
              <Image src="/quote_8.png" alt="01" width={26} height={24} />
            </div>
            <div className=" font-semibold text-[24px] leading-[32px] tracking-[2px] text-[#333333]">
              {items[activeIndex].title}
            </div>
            <div className="min-h-[150px] font-normal text-[18px] [@media(max-width:660px)]:text-[14px] leading-[34px] tracking-[0px] text-[#666666]">
              {items[activeIndex].content}
            </div>
            <div className="h-[34px] font-normal text-[18px] [@media(max-width:660px)]:text-[14px] leading-[34px] tracking-[0px] text-right text-[#666666]">
              {items[activeIndex].author}
            </div>
            <div className="flex flex-grow gap-[6px]">
              {items.map((item, index) => (
                <div
                  key={item.id}
                  className={`h-[6px] rounded-[6px] ${
                    index === activeIndex
                      ? "w-[28px] bg-[#1DBA55]"
                      : "w-[10px] bg-[#D9D9D9]"
                  }`}
                  onClick={() => {
                    setActiveIndex(index);
                    setFade(true);
                    window.Log.action(
                      "teacher_comment_slide",
                      {
                        button: "老师好评",
                        user_access_port: deviceType,
                      },
                      "HWOfficialMainPage",
                    );
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Teacher;
